<template>
  <div class="animated fadeIn">
      <b-row>
         <b-col sm="12" md="12">
            <b-card v-if="display_journalier" class="card-accent-info" header="DETAILS DES OPERATIONS DU JOUR">
                <div class="bd-example">
                  
                  <dl class="row">
                      
                      <dt class="col-sm-3" style="text-align:right;">Nombre d'entrée : </dt>
                      <dd class="col-sm-2" style="text-align:right;">{{ solde_planning.nb_total_entre }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-3" style="text-align:right;">Nombre de sortie : </dt>
                      <dd class="col-sm-2" style="text-align:right;">{{ solde_planning.nb_sorti }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-3" style="text-align:right;">Montant entrée : </dt>
                      <dd class="col-sm-2" style="text-align:right;">{{ solde_planning.montant_operation_entre }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-3" style="text-align:right;">Montant sortie : </dt>
                      <dd class="col-sm-2" style="text-align:right;">{{ solde_planning.montant_sorti }} </dd>
                  </dl>
                  <!-- <dl class="row">
                      
                      <dt class="col-sm-3" style="text-align:right;">Montant opérations entrées</dt>
                      <dd class="col-sm-2" style="text-align:right;">{{ solde_planning.montant_operation_entre }} </dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-3" style="text-align:right;">Montant approvisionnements entrés :</dt>
                      <dd class="col-sm-1" style="text-align:right;">{{ solde_planning.montant_appro_entre }} </dd>
                  </dl> -->
                  <dl class="row">
                       <dt class="col-sm-3" style="text-align:right;">Commissions totales : </dt>
                      <dd class="col-sm-2" style="text-align:right;">{{ solde_planning.commission_totale }} </dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-3" style="text-align:right;">Solde de caisse : </dt>
                      <dd class="col-sm-2" style="text-align:right;">{{ solde_planning.soldecaisse }} </dd>
                  </dl>
                  <dl class="row">
                      <!-- <dt class="col-sm-3" style="text-align:right;">Commissions totales : </dt>
                      <dd class="col-sm-2" style="text-align:right;">{{ solde_planning.commission_totale }} </dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd> -->
                      <!-- <dt class="col-sm-3" style="text-align:right;">Frais </dt>
                      <dd class="col-sm-2" style="text-align:right;">{{ solde_planning.frais }} </dd> -->
                  </dl>
                </div>
            </b-card>
            <b-card class="card-accent-success" header="SOLDE GUICHET ">
                <div class="bd-example">
                  <dl class="row">
                      <dt class="col-sm-3" style="text-align:right;">Solde : </dt>
                      <dd class="col-sm-2" style="text-align:right;">{{solde_total}}</dd>
                      <!-- <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd> -->
                      <!-- <dt class="col-sm-2">Solde en caisse</dt>
                      <dd class="col-sm-3">{{ entity.nom_commercial }}</dd> -->
                  </dl>
                </div>
            </b-card>
          </b-col>
      </b-row>

  </div>
</template>

<script>
import api from '../../../api/';
export default {
    name: 'tables',
    data(){
        return {
            solde_total :'',
            solde_planning :'',
            display_journalier:false
        }
    },
    methods:{
        async solde(){
            this.userConnected = await store.getters['auth/get_user']
            if (this.userConnected.role.toUpperCase() == 'RESPONSABLE POSTE'|| this.userConnected.role.toUpperCase() == 'RESPONSABLE DISTRIBUTEUR'){
                this.display_journalier=false
                let response = await api.entity.get_balance_entites(token)
                
                this.solde_total = response.data.data.solde
                localStorage.setItem('solde', response.data.data.solde)
            }else{
                // display all amount 
                this.display_journalier=true
                let response = await api.atm.get_auth_guichets(token)
                this.solde_total = response.data.data.solde.toLocaleString("fr-FR", {style: "currency", currency: "XOF"})
                //localStorage.setItem('solde', solde.data.data.solde)
            
                //display amount by 
               
                this.solde_planning = await api.planning.get_solde_planning().then((data)=>{
                    console.log("solde t : ",data)
                    return data.data.data[0]
                })
                
            }
        }
    },
    mounted(){
        this.solde()
    }
}
</script>
